export default __webpack_public_path__ + "locales/ko-KR/JavascriptSdk.json?hash=b43bad49c68f1764ff4d000975243863";